"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNode = void 0;
/**
 * 'true' if running in Node.js, or 'false' otherwise.
 * We check for version truthiness since most shims will have that as empty string.
 */
// eslint-disable-next-line no-undef
exports.isNode = typeof process !== 'undefined' && typeof process.version !== 'undefined' && !!process.version ? true : false;
